import React, { Component } from "react"

import Sobre from "./Sobre"
import Planos from "./Planos";

class Main extends Component {
  constructor(props) {
    super(props)

    this.state = {
      conquista: false,
      about: false,
      trails: false,
      tabAboutClicked: () => {
        document.querySelector("#myTab-HistoryDiv").classList.remove("myTabSeparator")
        this.setState({ conquista: false, about: true, trails: false })
      },
    }
  }

  render() {
    const { tabAboutClicked, about } = this.state
    return (
      <>
      {this.props.openPlansModal && <Planos setEndOfMonth={() => {}} />}
      <div>
        <ul className="nav nav-tabs nav-fill" id="myTab" role="tablist">
          <li className="nav-item">
            <a
              onClick={tabAboutClicked}
              className="nav-link active"
              id="sobre-tab"
              data-toggle="tab"
              href="#sobre"
              role="tab"
              aria-controls="sobre"
              aria-selected="true"
            >
              <span data-tip="Sobre perfil">
                <i className="fa fa-user" aria-hidden="true" /> Sobre
              </span>
            </a>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane fade show active"
            id="sobre"
            role="tabpanel"
            aria-labelledby="sobre-tab"
          >
            <Sobre about={about} />
          </div>
        </div>
      </div>
      </>
    )
  }
}

export default Main
